<app-page-header
  [isMenuOpen]="isMenuOpen()"
  [showActions]="showHeaderActions()"
  (menuOpen)="openMenu()"
  (menuClose)="closeMenu()"></app-page-header>
<main class="main-content" [hidden]="isMenuOpen()" [attr.aria-hidden]="isMenuOpen()">
  <router-outlet />
</main>
@if (isMenuOpen()) {
  <app-nav-menu></app-nav-menu>
}
<app-page-footer></app-page-footer>
